import { Fragment, FunctionalComponent, h } from 'preact';
import { useContext, useMemo, memo } from 'preact/compat';
import { useTranslation } from 'hooks';
import { AccessibilityFeaturesContext } from '../use-accessibility-fetures';

interface FeatureIconProps {
  featureName: string;
}

const FeatureIconComponent: FunctionalComponent<FeatureIconProps> = ({ featureName }) => {
  const { translate } = useTranslation();
  const { allyFeaturesState } = useContext(AccessibilityFeaturesContext);

  const { actionState = 0, actionStatesMeta } = allyFeaturesState[featureName] || {};

  const currentActionStatesMeta = useMemo(
    () => actionStatesMeta[`${actionState}`] || actionStatesMeta['0'] || {},
    [actionStatesMeta, actionState],
  );

  const iconClassName = `icon icon-${currentActionStatesMeta.iconClass || 'default'}`;
  const labelText = translate(currentActionStatesMeta.label || '');
  const iconWrapperClassName =
    `uwaw-features__item__icon ${currentActionStatesMeta.iconWrapClass || ''}`.trim();

  return (
    <Fragment>
      <span className={iconWrapperClassName}>
        <span className={iconClassName} />
      </span>
      <span className="uwaw-features__item__name">{labelText}</span>
    </Fragment>
  );
};

export const FeatureIcon = memo(FeatureIconComponent);
